/** Mieterportal 2.0: Einstellungen des Mieters (`mieter.portal_json`), Mehrfachaktionen, Packliste. */
import { z } from "zod";

export const KACHELN = ["erfassen", "etiketten", "packliste", "regal", "lagerhueter", "abrechnung", "teilen", "statistik", "aktionen", "inventur", "termin", "sammel"] as const;
export type Kachel = (typeof KACHELN)[number];

export const Vorlage = z.object({
  bezeichnung: z.string().trim().min(1).max(80),
  preisCent: z.number().int().min(1).max(10_000_000),
  kategorie: z.string().trim().max(40).default(""),
});
export type Vorlage = z.infer<typeof Vorlage>;

export const PortalEinstellungen = z.object({
  konfetti: z.boolean().default(true),
  ton: z.boolean().default(false),
  kacheln: z.array(z.enum(KACHELN)).max(10).default(["erfassen", "etiketten", "packliste", "regal", "teilen", "statistik"]),
  vorlagen: z.array(Vorlage).max(20).default([]),
  onboardingAusgeblendet: z.boolean().default(false),
  /** Zuletzt benutzte Kategorien (für Chips beim Erfassen). */
  kategorien: z.array(z.string().trim().max(40)).max(12).default([]),
  /** MP-B: öffentliche Regal-Seite, Push, Wochenmail, Spende. */
  oeffentlich: z.boolean().default(false),
  anzeigename: z.string().trim().max(40).default(""),
  push: z.enum(["sofort", "taeglich", "aus"]).default("sofort"),
  wochenmail: z.boolean().default(true),
  spende: z.boolean().default(false),
  /** MP-C: Kalender-Abo (ICS) – Token statt Sitzung. */
  kalenderToken: z.string().nullable().default(null),
  /** MP-D: Verkaufsziel (0 = kein Ziel) mit Push, sobald es erreicht ist. */
  /** MP-E: Sprache des Portals und Anzeige (große Schrift, Einfach-Modus). */
  sprache: z.enum(["de", "en", "uk", "tr"]).default("de"),
  anzeige: z.object({ grosseSchrift: z.boolean().default(false), einfach: z.boolean().default(false) }).default({ grosseSchrift: false, einfach: false }),
  ziel: z
    .object({ zeitraum: z.enum(["tag", "woche", "monat"]).default("monat"), betragCent: z.number().int().min(0).max(10_000_000).default(0) })
    .default({ zeitraum: "monat", betragCent: 0 }),
});
export type PortalEinstellungen = z.infer<typeof PortalEinstellungen>;
export const PORTAL_STANDARD: PortalEinstellungen = PortalEinstellungen.parse({});

export const ArtikelIds = z.object({ artikelIds: z.array(z.uuid()).min(1).max(200) });
export const StatusMehrere = ArtikelIds.extend({ status: z.enum(["abgeholt", "entfernt", "im_regal"]) });

/** Lagerhüter-Fahrplan: ab 30 Tagen −10 %, ab 60 −25 %, ab 90 abholen. */
export function lagerhueterStufe(tage: number): { stufe: 0 | 1 | 2 | 3; prozent: number; text: string } {
  if (tage >= 90) return { stufe: 3, prozent: 40, text: "Liegt seit 3 Monaten – 40 % günstiger oder abholen" };
  if (tage >= 60) return { stufe: 2, prozent: 25, text: "Liegt seit 2 Monaten – 25 % günstiger probieren" };
  if (tage >= 30) return { stufe: 1, prozent: 10, text: "Liegt seit einem Monat – 10 % günstiger probieren" };
  return { stufe: 0, prozent: 0, text: "" };
}
